import { memo } from "react";

import { Box } from "@mui/material";

import {
  CELL_SIZE,
  CELL_GAP,
  MONTH_HEADER_HEIGHT,
} from "../constants/timelineConstants";

function TimelineMonthsRow({ weeks }) {
  const months = [];

  weeks.forEach((week) => {
    const representativeDate = week.add(3, "day");

    const monthKey = representativeDate.format("YYYY-MM");

    const existing = months.find((m) => m.key === monthKey);

    if (existing) {
      existing.weeks += 1;
      return;
    }

    months.push({
      key: monthKey,
      label: representativeDate.format("MMM"),
      weeks: 1,
    });
  });

  return (
    <Box
      sx={{
        display: "flex",
        height: MONTH_HEADER_HEIGHT,
        alignItems: "center",
      }}
    >
      {months.map((month) => (
        <Box
          key={month.key}
          sx={{
            width: month.weeks * CELL_SIZE + (month.weeks - 1) * CELL_GAP,

            textAlign: "left",
            paddingLeft: 2,
            fontSize: 10,
            fontWeight: 600,
            color: "text.secondary",
          }}
        >
          {month.label}
        </Box>
      ))}
    </Box>
  );
}

export default memo(TimelineMonthsRow);
